import React, { useState, useEffect, useRef } from 'react';
import { Icon } from 'Components/frameworks/icon/Icon';
import { ICONS } from 'Components/utils/icon/icons';
type Props = {
  timeout: number; // seconds
};
export const WeChatTimer = ({ timeout }: Props) => {
  const [timer, setTimer] = useState(timeout);
  const timerInterval = useRef();
  useEffect(() => {
    timerInterval.current = setInterval(() => {
      setTimer((prevTimer) => {
        if (prevTimer === 1) {
          // @ts-expect-error TODO(flow-migration)
          clearInterval(timerInterval.current);
        }

        return prevTimer - 1;
      });
    }, 1000);
    return () => {
      clearInterval(timerInterval.current);
    };
  }, []);
  const timerInMinutes = timer / 60;
  const minutes = Math.floor(timerInMinutes % 60);
  const seconds = Math.floor(timer % 60);
  const secondsIn2digits = seconds < 10 ? `0${seconds}` : seconds;
  return (
    <div className="pt-15 text-center text-sienna">
      <Icon className="align-middle" name={ICONS.DURATION} width="1rem" />
      <div className="ms-10 inline-block">
        {minutes}:{secondsIn2digits}
      </div>
    </div>
  );
};
